import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import StatsigComponent from './statsig-component'
import * as serviceWorker from './serviceWorker'
import TagManager from 'react-gtm-module'
import '@mercadoni/gungnir/dist/css/gungnir.css'
import './styles/index.less'
import Main from './Main/Scenes'
import { I18nextProvider } from 'react-i18next'
import i18n from './config/i18n'
import { AuthProvider } from './auth/Auth.context'
import { WrapperAuthProvider } from './auth/providers'

const GTM_ID = process.env.REACT_APP_GTM_ID
if (GTM_ID) {
  const tagManagerArgs = {
    gtmId: GTM_ID
  }
  TagManager.initialize(tagManagerArgs)
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('../firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Registration successful, scope is:', registration.scope)
    })
    .catch((err) => {
      console.log('Service worker registration failed, error:', err)
    })
}

const App = (props) => {
  const { store } = props
  return (
    <WrapperAuthProvider>
      <AuthProvider>
        <StatsigComponent>
          <BrowserRouter>
            <I18nextProvider i18n={i18n}>
              <Provider store={store}>
                <Main />
              </Provider>
            </I18nextProvider>
          </BrowserRouter>
        </StatsigComponent>
      </AuthProvider>
    </WrapperAuthProvider>
  )
}

export default App

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
